import { useState, KeyboardEvent } from 'react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';
import { MicButton } from '@/components/common/MicButton';

interface QuickTaskInputProps {
  onAdd: (text: string) => void;
}

export function QuickTaskInput({ onAdd }: QuickTaskInputProps) {
  const [text, setText] = useState('');

  const handleAdd = () => {
    if (text.trim()) {
      onAdd(text.trim());
      setText('');
    }
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handleAdd();
    }
  };

  return (
    <div className="flex gap-2">
      <Input
        id="quick-task-input"
        data-quick-task-input
        value={text}
        onChange={(e) => setText(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder="Add a quick task..."
        className="flex-1 bg-background/50 border-border/50"
      />
      <MicButton
        ariaLabel="Dictate task"
        onTranscript={(spoken) =>
          setText((prev) => (prev ? `${prev} ${spoken}` : spoken))
        }
      />
      <Button
        size="icon"
        variant="secondary"
        onClick={handleAdd}
        disabled={!text.trim()}
        aria-label="Add task"
        className="shrink-0"
      >
        <Plus className="h-4 w-4" />
      </Button>
    </div>
  );
}
